import '../../App.css';
import Seo from '../../components/common/atoms/Seo';
import seoData from '../../json/seo.json';
import textData from '../../json/text.json';
import Header from '../../components/menu/organisms/Header';
import Footer from  '../../components/footer/Footer';
import TopicPath from '../../components/common/atoms/TopicPath';
import H1 from '../../components/common/atoms/H1';
import ConceptContent from '../../components/company/organisms/ConceptContent';

/**
 * キメラワークスとはページ
 * @returns 
 */
function Concept() {
  const links = [{link:'/concept', pageName:textData['menu.concept']['ja']}];
  const titleText = textData['menu.concept']['ja'];
  return (

    <div>
      <Seo title={titleText} description={seoData.pages.concept.description} path='/concept' />

      <header>
        <Header />
      </header>
      
      <main className="main-content">
        <TopicPath links={links} />
        <H1 text={titleText}/>
        <ConceptContent />
      </main>
      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Concept;
